import { useShowNotification } from 'js/components/common/Notifications';
import { useCallback, useState } from 'react';
import { join, leave } from '../actions';

export const getNotification = (error, type, useTournament, style) => {
    const { errorCode } = error?.response?.data || error?.data || error || {};

    return {
        iconType: errorCode ? 'error' : 'joinLeaderboardNotification',
        tKey: `playtech.mobile.system.casino-leaderboard.notification.${type}.${errorCode ? 'error' : useTournament ? 'success.tournament' : 'success'}`,
        className: style
    };
};

export default type => ({ leaderboardId, useTournament, style, trackJoinEventClick, trackLeaveEventClick, missions }) => {
    const [disabled, setDisabled] = useState(false);
    const showNotification = useShowNotification();
    const onJoinButtonClick = (lbId) => {
        const str = `{"_type": "com.pt.casino.client.integration.overlay.joinNotification", "id":${lbId}}`;
        window.parent?.postMessage(str, '*');
    };

    const onClick = useCallback(() => {
        if (trackJoinEventClick) {
            trackJoinEventClick();
        }
        if (trackLeaveEventClick) {
            trackLeaveEventClick();
        }
        const success = (response) => {
            if (!missions) {
                showNotification(getNotification(response, type, useTournament, style));
            }
            setDisabled(false);
        };

        const fail = (error) => {
            showNotification(getNotification(error, type, useTournament, style));
            setDisabled(false);
        };

        setDisabled(true);

        if (type === 'join') {
            onJoinButtonClick(leaderboardId);
            join({ leaderboardId }).then(success, fail);
        } else {
            leave({ leaderboardId }).then(success, fail);
        }
    }, [leaderboardId, useTournament, showNotification, style, trackJoinEventClick, trackLeaveEventClick, missions]);

    return {
        disabled,
        onClick
    };
};
